import React from 'react';
import { Button, Icon, Table, Header, Popup, Loader, Form, Input, Checkbox, TextArea, Grid } from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import { fetchFaculties } from '../../Lookups/util';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const NoDataMessage = () => <p>Nema predmeta.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema predmeta.</p>;

export default class Courses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            courseName: '',

            addNewCourse: false,
            loading: true,

            englishName: null,
            name: '',
            comment: '',
            faculty: '',
            faculties: [],
            facultyList: [],

            isGlobal: false,
            finalCourse: false,

            nameErr: false,
            facultyErr: false,

            editMode: false,
            results: []


        };
        this.getCourses = this.getCourses.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChangeD = this.handleInputChangeD.bind(this);
        this.addCourse = this.addCourse.bind(this);
        this.edit = this.edit.bind(this);
        this.getFacultyName = this.getFacultyName.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('comment');
        this.getCourses();

        axios.all([fetchFaculties()])
            .then(axios.spread((facultiesRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                this.setState({ faculties });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch faculties');
            });
    }

    getCourses() {
        axios.get(`course/basic/${this.props.orgUnitId}/false`)
            .then(res => {
                this.setState({ data: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
    }

    addCourse(name, englishName, comment, globalCourse, finalCourse, faculty, facultyList) {
        if (!faculty || !name) {
            toast('Morate unijeti obavezna polja');
            if (!faculty) { this.setState({ facultyErr: true }); } else { this.setState({ facultyErr: false }); }
            if (!name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
        } else {
            const mainFaculty = { id: faculty, name: this.getFacultyName(faculty) };
            const organizationalUnits = facultyList.map(el => ({ id: el, name: this.getFacultyName(el) }));
            organizationalUnits.push({ id: faculty, name: this.getFacultyName(faculty) });
            let newCourse = {};
            let language = { twoLetterCode: 'en' };
            let translations = [{ name: englishName, language }];

            if (name) newCourse = { ...newCourse, name };
            if (globalCourse) newCourse = { ...newCourse, globalCourse };
            if (finalCourse !== null && finalCourse !== undefined) newCourse = { ...newCourse, finalCourse };
            if (comment) newCourse = { ...newCourse, comment };
            if (mainFaculty) newCourse = { ...newCourse, mainFaculty };
            if (organizationalUnits) newCourse = { ...newCourse, organizationalUnits };
            if (englishName !== null) newCourse = { ...newCourse, translations };

            axios.post('/course/basic/', { ...newCourse })
                .then(res => {
                    toast('Uspješno ste kreirali predmet!');
                    this.setState({ loading: true });
                    this.getCourses();
                })
                .catch(err => {
                    toast('Došlo je do greške! Kreiranje predmeta nije uspjelo.');
                });
            this.setState({ addNewCourse: false });
        }
        this.setState({
            englishName: null,
            name: '',
            comment: ''
        });
    }

    edit(optLock, id) {
        const {
            name, englishName, comment, finalCourse
        } = this.state;

        let newCourse = {};
        let language = { twoLetterCode: 'en' };
        let translations = [{ name: englishName, language }];

        if (name) newCourse = { ...newCourse, name };
        if (englishName) newCourse = { ...newCourse, translations };
        if (id) newCourse = { ...newCourse, id };
        if (optLock) newCourse = { ...newCourse, optLock };
        if (comment) newCourse = { ...newCourse, comment };
        if (finalCourse !== null && finalCourse !== undefined) newCourse = { ...newCourse, finalCourse };

        axios.put('/course/basic/', { ...newCourse })
            .then(res => {
                toast('Predmet je uspješno izmijenjen!');
                this.setState({ loading: true });
                this.getCourses();
            })
            .catch(err => {
                toast('Došlo je do greške! Predmet nije izmijenjen.');
            });
        this.setState({
            editMode: false,
            englishName: null,
            name: '',
            comment: ''
        });
    }

    getFacultyName(id) {
        const { faculties } = this.state;
        const selected = faculties.find(el => el.id === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    handleInputChangeD(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        const { editMode } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>

                {/* {this.getDataToRender().length ? */}
                <Table celled selectable compact>

                    <Table.Header >
                        <Table.Row>
                            <Table.HeaderCell colSpan={7} >
                                <div style={{ paddingLeft: '30px' }}>
                                    <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['name', 'englishName']} />
                                </div>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>
                                <Header as="h4">
                                    <Header.Content>
                                        Naziv predmeta
                                    </Header.Content>
                                    <Header.Subheader>B/H/S jezik</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Header as="h4">
                                    <Header.Content>
                                        Naziv predmeta
                                    </Header.Content>
                                    <Header.Subheader>Engleski jezik</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell width="2">
                                Napomena
                            </Table.HeaderCell>
                            <Table.HeaderCell width="1">
                                Globalni predmet
                            </Table.HeaderCell>
                            <Table.HeaderCell width="1">
                                Finalni predmet
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Matični fakultet
                            </Table.HeaderCell>
                            <Table.HeaderCell width="2" as="th" verticalAlign="middle" textAlign="center">
                                <Popup
                                    content="Kreiraj predmet"
                                    position="top center"
                                    trigger={
                                        <Button
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this.setState({
                                                englishName: null,
                                                name: '',
                                                comment: '',
                                                addNewCourse: true,
                                                editMode: false
                                            })}
                                        />}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.addNewCourse && <Table.Row>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field required error={this.state.nameErr}>
                                        <label>Naziv predmeta</label>
                                        <input
                                            value={this.state.name}
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                            name="name"
                                            placeholder="Unesite naziv predmeta"
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field>
                                        <label>Naziv predmeta na engleskom jeziku</label>
                                        <input
                                            value={this.state.englishName}
                                            onChange={(e) => this.setState({ englishName: e.target.value })}
                                            name="englishName"
                                            placeholder="Unesite naziv predmeta na engleskom jeziku"
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field
                                        label="Napomena"
                                        control={TextArea}
                                        name="comment"
                                        rows={1}
                                        value={this.state.comment}
                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                        // onChange={this.handleInputChange}
                                        placeholder="Napomena..."
                                    />
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field>
                                        <label>  DA / NE</label>
                                        <Checkbox
                                            label=""
                                            value={this.state.isGlobal}
                                            onChange={(e) => this.setState({ isGlobal: !this.state.isGlobal })}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field>
                                        <label>  DA / NE</label>
                                        <Checkbox
                                            label=""
                                            checked={this.state.finalCourse}
                                            onChange={(e) => this.setState({ finalCourse: !this.state.finalCourse })}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell>
                                <Form>
                                    <Form.Field required>
                                        <label>  Matični fakultet</label>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite matični fakultet"
                                            value={this.state.faculty}
                                            onChange={this.handleInputChangeD}
                                            name="faculty"
                                            options={this.state.faculties}
                                            search
                                            fluid
                                            error={this.state.facultyErr}
                                        />
                                    </Form.Field>
                                    {this.state.isGlobal && <Form.Field>
                                        <label>Fakultet(i)</label>
                                        <Form.Dropdown
                                            clearable
                                            multiple
                                            selection
                                            placeholder="Odaberite jedan ili više fakulteta"
                                            value={this.state.facultyList}
                                            onChange={this.handleInputChangeD}
                                            name="facultyList"
                                            options={this.state.faculties.filter(el => el.id !== this.state.faculty)}
                                            search
                                            fluid
                                        />
                                    </Form.Field>}
                                </Form>
                            </Table.Cell>
                            <Table.Cell textAlign="center" verticalAlign="middle" width="1">
                                <Button
                                    size="small"
                                    color="blue"
                                    icon="check"
                                    circular
                                    onClick={
                                        () => {
                                            this.addCourse(
                                                this.state.name,
                                                this.state.englishName,
                                                this.state.comment,
                                                this.state.isGlobal,
                                                this.state.finalCourse,
                                                this.state.faculty,
                                                this.state.facultyList
                                            );
                                        }
                                    }
                                />
                                <Button
                                    size="small"
                                    color="blue"
                                    circular
                                    basic="true"
                                    icon="close"
                                    onClick={() => this.setState({ editMode: false, addNewCourse: false })}
                                />
                            </Table.Cell>
                        </Table.Row>}
                        {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field required error={this.state.nameErr}>
                                                <label>Naziv predmeta</label>
                                                <input
                                                    value={this.state.name}
                                                    onChange={(e) => this.setState({ name: e.target.value })}
                                                    name="name"
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field>
                                                <label>Naziv na engleskom</label>
                                                <input
                                                    value={this.state.englishName}
                                                    onChange={(e) => this.setState({ englishName: e.target.value })}
                                                    name="englishName"
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.englishName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {editMode === index ?
                                        <Form noValidate>
                                            <Form.Field
                                                label="Napomena"
                                                control={TextArea}
                                                name="comment"
                                                rows={1}
                                                value={this.state.comment}
                                                onChange={(e) => this.setState({ comment: e.target.value })}
                                                // onChange={this.handleInputChange}
                                                placeholder="Napomena..."
                                            />
                                        </Form>
                                        : el.comment}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="1">
                                    {editMode === index ?
                                        <Form>
                                            <Form.Field>
                                                <label>  DA / NE</label>
                                                <Checkbox
                                                    label=""
                                                    value={this.state.isGlobal}
                                                    onChange={(e) => this.setState({ isGlobal: !this.state.isGlobal })}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.globalCourse ? 'DA' : 'NE'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="1">
                                    {editMode === index ?
                                        <Form>
                                            <Form.Field>
                                                <label>  DA / NE</label>
                                                <Checkbox
                                                    label=""
                                                    checked={this.state.finalCourse}
                                                    onChange={(e) => this.setState({ finalCourse: !this.state.finalCourse })}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : el.finalCourse ? 'DA' : 'NE'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {editMode === index ?
                                        <Form>
                                            <Form.Field required>
                                                <label>  Matični fakultet</label>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite matični fakultet"
                                                    value={this.state.mainFaculty.id}
                                                    onChange={this.handleInputChangeD}
                                                    name="mainFaculty"
                                                    options={this.state.faculties}
                                                    search
                                                    fluid
                                                    error={this.state.facultyErr}
                                                />
                                            </Form.Field>
                                            {this.state.isGlobal && <Form.Field>
                                                <label>Fakultet(i)</label>
                                                <Form.Dropdown
                                                    clearable
                                                    multiple
                                                    selection
                                                    placeholder="Odaberite jedan ili više fakulteta"
                                                    value={this.state.facultyList}
                                                    onChange={this.handleInputChangeD}
                                                    name="facultyList"
                                                    options={this.state.faculties.filter(el => el.id !== this.state.faculty)}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>}
                                        </Form>
                                        : el.mainFaculty ? el.mainFaculty.name : ''}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" width="2">
                                    {editMode === index ?
                                        <div>
                                            <Button size="small" color="blue" icon="check" circular onClick={() => this.edit(el.optLock, el.id)} />
                                            <Button
                                                size="small"
                                                color="blue"
                                                basic="true"
                                                circular
                                                icon="close"
                                                onClick={() => this.setState({
                                                    editMode: false, addNewCourse: false
                                                })}
                                            />
                                        </div>
                                        : <div>
                                            <Popup
                                                content="Izmijeni predmet"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        color="green"
                                                        circular
                                                        icon="pencil"
                                                        size="small"
                                                        onClick={() => this.setState({
                                                            editMode: index,
                                                            comment: el.comment,
                                                            name: el.name,
                                                            englishName: el.englishName,
                                                            globalCourse: el.globalCourse,
                                                            finalCourse: el.finalCourse,
                                                            mainFaculty: el.mainFaculty,
                                                            optLock: el.optLock
                                                        })}
                                                    >
                                                    </Button>}
                                            >
                                            </Popup>

                                            <Link to={{ pathname: '/predmeti/detalji-i-arhiviranje', state: { name: el.name, id: el.id } }}>
                                                <Popup
                                                    content="Detalji / Arhiviranje"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            color="teal"
                                                            size="small"
                                                            circular
                                                            icon="align justify"
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                            </Link>

                                            <Link to={{
                                                pathname: '/predmeti/detalji',
                                                state: { courseBasicId: el.id, courseBasicName: el.name }
                                            }}>
                                                <Popup
                                                    content="Studijski programi i ciklusi"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            color="teal"
                                                            size="small"
                                                            circular
                                                            icon="info"
                                                            onClick={() => localStorage.setItem('courseComment', el.comment)}
                                                        />
                                                    }
                                                />
                                            </Link>

                                            <Link to={{ pathname: '/predmeti/implementacije' }}>

                                                <Popup
                                                    content="Implementacije"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            color="blue"
                                                            size="small"
                                                            circular
                                                            icon="folder open"

                                                            onClick={() => {
                                                                localStorage.setItem('courseBasicId', el.id);
                                                                localStorage.setItem('courseBasicName', el.name);
                                                                localStorage.setItem('courseComment', el.comment);
                                                                localStorage.removeItem('disableCreateImplementations');
                                                            }}
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>

                                            </Link>

                                            <Link to={{ pathname: '/predmeti/kreiranje-implementacije' }}>
                                                <Popup
                                                    content="Kreiranje implementacije"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            color="teal"
                                                            size="small"
                                                            circular
                                                            icon="add"
                                                            onClick={() => {
                                                                localStorage.setItem('courseBasicName', el.name);
                                                                localStorage.setItem('courseBasicId', el.id);
                                                                { el.comment && localStorage.setItem('comment', el.comment); }
                                                            }}
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                            </Link>
                                        </div>}
                                </Table.Cell>

                            </Table.Row>))}
                    </Table.Body>
                </Table>
                {/*    : this.state.filterMode ? */}
                {/*        <div><br /><NoFilterDataMessage /></div> */}
                {/*        : <div><br /><NoDataMessage /></div> */}
                {/* } */}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/Courses.js